import React, { useEffect, useState } from 'react';
import ConfiguratorBase from './ConfiguratorBase';
import ConfiguratorTabs from './Tabs/ConfiguratorTabs';
import ConfiguratorLoadingState from './ConfiguratorLoadingState';
import { useSelector, useDispatch } from 'react-redux';
import { get } from '../../Services/http';
import { load,renderProductGoogleAnalytics } from '../../Actions/Configurator.action';

const ConfiguratorDialog = () => {
  const dispatch = useDispatch(),
    isOpen = useSelector((state) => state.configurator.isOpen),
    id = useSelector((state) => state.configurator.id),
    orderRow = useSelector((state) => state.configurator.orderRow),
    [isLoading, setIsLoading] = useState(false),
    selectedProductServiceTab = useSelector((state) => state.configurator.selectedProductServiceTab),
    isWide = selectedProductServiceTab === 2;

  useEffect(() => {
    setIsLoading(true);
    if (id) {
      const timingLabel = `loading configurator (${id})`;
      var orderRowParam = orderRow !== null && orderRow !== undefined ? '&orderRow=' + orderRow : '';
      console.time(timingLabel);
      get('/api/configurator/load?id=' + id + '&channelId=' + window.__litium.constants.currentChannelId + orderRowParam)
        .then((response) => response.json())
        .then((data) => {
          dispatch(load(data));
          renderProductGoogleAnalytics(data)
        }).finally(() => {
          console.timeEnd(timingLabel);
          setIsLoading(false);
        });
    }
  }, [id]);

  return (
    <dialog className={'configurator-dialog' + (isWide ? ' configurator-dialog--wide' : '')} open={isOpen}>
        <ConfiguratorTabs isLoading={isLoading} />
        {isLoading ? <ConfiguratorLoadingState /> : <ConfiguratorBase />}
    </dialog>
  );
};

export default ConfiguratorDialog;
